import { Inbox, Loader2, Merge, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface MergeUsersToolbarProps {
  selectedCount: number;
  onMerge: () => void;
  onClear: () => void;
  onGenerateMailboxes: () => void;
  isGeneratingMailboxes?: boolean;
}

export const MergeUsersToolbar = ({
  selectedCount,
  onMerge,
  onClear,
  onGenerateMailboxes,
  isGeneratingMailboxes,
}: MergeUsersToolbarProps) => {
  if (selectedCount === 0) return null;

  const canMerge = selectedCount >= 2 && selectedCount <= 3;

  return (
    <div className="flex items-center justify-between gap-3 mb-4 p-3 rounded-lg bg-genie-primary/5 border border-genie-primary/20">
      <span className="text-sm font-medium text-gray-700">{selectedCount} selected</span>
      <div className="flex items-center gap-2">
        <Button
          size="sm"
          variant="outline"
          onClick={onGenerateMailboxes}
          disabled={isGeneratingMailboxes}
        >
          {isGeneratingMailboxes ? (
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
          ) : (
            <Inbox className="h-4 w-4 mr-2" />
          )}
          Generate Genie Mailboxes
        </Button>
        <Button
          size="sm"
          onClick={onMerge}
          disabled={!canMerge}
          title={canMerge ? undefined : 'Select 2 or 3 accounts to merge'}
          className="bg-genie-primary hover:bg-genie-primary/90 text-white"
        >
          <Merge className="h-4 w-4 mr-2" />
          Merge Users
        </Button>
        <Button size="sm" variant="ghost" onClick={onClear} className="text-gray-500 hover:text-gray-700">
          <X className="h-4 w-4 mr-1" />
          Clear
        </Button>
      </div>
    </div>
  );
};
